import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { authHeader } from "../../../../../helpers";

const BookingSetFiles = ({ bookingId, setId }) => {
  const fileRef = useRef();

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  // ===========================
  // GET SET FILES
  // ===========================
  const fetchFiles = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_APIURL}booking/booking-kit-files/${bookingId}`,
        {
          headers: authHeader(),
          params: {
            setId: setId
   
          }
        }
      );

      setFiles(res.data.files || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (setId) {
      fetchFiles();
    }
  }, [setId]);

  // ===========================
  // UPLOAD
  // ===========================
  const handleChange = async (e) => {
    const selectedFiles = e.target.files;

    if (!selectedFiles.length) return;

    const formData = new FormData();

    for (let file of selectedFiles) {
      formData.append("files", file);
    }

    formData.append("id", bookingId);
    formData.append("setId", setId);

    try {
      setLoading(true);

      await axios.post(
        `${process.env.REACT_APP_APIURL}booking/upload-booking-files`,
        formData,
        {
          headers: {
            ...authHeader(),
            "Content-Type": "multipart/form-data",
          },
        }
      );

      fetchFiles();
    } catch (err) {
      console.error(err);
      alert("Upload Failed");
    } finally {
      setLoading(false);
      e.target.value = null;
    }
  };

  // ===========================
  // DELETE
  // ===========================
  const handleDelete = async (id) => {
    if (!window.confirm("Delete Image?")) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_APIURL}booking/delete-booking-file/${id}`,
        {
          headers: authHeader(),
        }
      );

      fetchFiles();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="d-flex justify-content-end align-items-center flex-wrap">

      {files.map((file) => {

        const image =
          `${process.env.REACT_APP_APIURL}assets/uploads/kitDocuments/bookingFiles/${file.file_path}`;

        return (
          <div
            key={file._id}
            style={{
              position: "relative",
              marginRight: 8,
              marginBottom: 8,
            }}
          >
            <img
              src={image}
              alt=""
              width="55"
              height="55"
              style={{
                borderRadius: 5,
                objectFit: "cover",
                border: "1px solid #ddd",
                cursor: "pointer",
              }}
              onClick={() => window.open(image)}
            />

            <button
              onClick={() => handleDelete(file._id)}
              style={{
                position: "absolute",
                top: -5,
                right: -5,
                border: 0,
                background: "red",
                color: "#fff",
                width: 18,
                height: 18,
                borderRadius: "50%",
                fontSize: 10,
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>
        );
      })}

      <button
        className="btn btn-sm btn-secondry"
        onClick={() => fileRef.current.click()}
        disabled={loading}
      >
        {loading ? "Uploading..." : "+ Image"}
      </button> 

      <input
        hidden
        ref={fileRef}
        type="file"
        multiple
        accept="image/*"
        onChange={handleChange}
      />

    </div>
  );
};

export default BookingSetFiles;